import type React from "react"

interface PlatformIconProps {
  platform: "hubspot" | "salesforce"
  size?: "small" | "medium" | "large"
}

const PlatformIcon: React.FC<PlatformIconProps> = ({ platform, size = "medium" }) => {
  const sizeClass = `platform-icon-${size}`

  if (platform === "salesforce") {
    return (
      <div className={`platform-icon-add salesforce ${sizeClass}`}>
        <img src="https://cdn.worldvectorlogo.com/logos/salesforce-2.svg" alt="Salesforce" />
      </div>
    )
  }

  return (
    <div className={`platform-icon-add hubspot ${sizeClass}`}>
      <img src="https://cdn.worldvectorlogo.com/logos/hubspot-1.svg" alt="HubSpot" />
    </div>
  )
}

export default PlatformIcon
